import React from 'react';
import { Input, Button, Upload } from 'antd';
import { SvgIconText } from 'freesia-ui';
import PropertyGridUtils from '../PropertyGridUtils';
import PropertyEditor from "../PropertyEditor";

export default class ImageSetEditor extends PropertyEditor {

    state = {
        values: []
    };

    constructor(props, context) {
        super(props, context);
    }

    onChange(e, index) {
        let values = this.state.values;
        values[index] = e.target.value;
        this.props.source.value = [...values];
        this.setState({ values: values });
    }

    onPropertyValueChanged(name, valOld, valNew, subName) {
        this.setState({ values: this.props.source.value || [] });
    }

    componentWillMount() {
        super.componentWillMount();
        this.setState({ values: this.props.source.value });
    }

    componentWillReceiveProps(nextProps) {
        super.componentWillReceiveProps(nextProps);
        this.setState({ values: nextProps.source.value });
    }

    simplifyValue(val) {

        if (!val)
            return null;
        if (val.length <= 500)
            return val;

        return val.substring(0, 500) + "...";
    }

    onUpload(e, index) {

        var reader = new FileReader();
        reader.onload = (e) => {
            let values = this.state.values;
            values[index] = e.target.result;
            this.props.source.value = [...values];
            this.setState({ values: values });
        }

        reader.readAsDataURL(e.file);
    }

    add() {
        let values = this.state.values;
        values.push("");
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    deleteItem(index) {
        let values = this.state.values;
        values.splice(index, 1);
        this.props.source.value = [...values];
        this.setState({
            values
        })
    }

    render() {
        let values = this.state.values;
        return (
            <div>
                {values.map((v, index) => {
                    return <div key={index}>
                        <Input className="image-editor" addonAfter={(
                            <span>
                                <Upload customRequest={e => this.onUpload(e, index)} showUploadList={false}>
                                    <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector" >
                                        <SvgIconText type="#anticon-folder5" />
                                    </Button>
                                </Upload>
                                <Button className="btn-bd-focus-none btn-pd-sm btn-bk-hover btn-bd-none image-selector" onClick={e => this.deleteItem(index)} >
                                    <SvgIconText type="#anticon-delete18" />
                                </Button>
                            </span>
                        )} value={this.simplifyValue(v)} onChange={e => this.onChange(e, index)} placeholder={this.props.source.placeholder || ""} />


                    </div>
                })}
                <Button onClick={this.add.bind(this)}>添加</Button>
            </div>
        );
    }
}

PropertyGridUtils.register("imageSet", (source, propertyGrid) => <ImageSetEditor source={source} propertyGrid={propertyGrid} />);